import React, { useState } from 'react';
import { useRouter } from 'next/router';
import Link from 'next/link';
import { MainTitle } from 'src/components/common/titles/MainH1';
import { ModalDialog } from 'src/components/common/modals';

import { MainTabs } from 'src/components/common/tabs';

import SignUpByEmail from 'src/components/auth/SignUp/SignUpByEmail';
import SignUpByPhone from 'src/components/auth/SignUp/SignUpByPhone';

import SignUpDialogIcon from 'assets/images/signUpDialogIcon.svg';
import AuthLayout from 'src/components/auth/AuthLayout';
import { LOGIN_PAGE_URL } from 'src/constants/links';

const EMAIL_TAB = 'By Email';
const PHONE_TAB = 'By Phone';

const Signup: React.FunctionComponent<{}> = () => {
    // const [showCodeInput, setShowCodeInput] = useState(false);
    const [showAccountCreatedModal, setShowAccountCreatedModal] =
        useState(false);

    const tabs = [EMAIL_TAB, PHONE_TAB];
    const [activeTab, setActiveTab] = useState(tabs[0]);
    const router = useRouter();

    return (
        <div>
            <ModalDialog
                open={showAccountCreatedModal}
                onClose={() => setShowAccountCreatedModal(false)}
                icon={<SignUpDialogIcon />}
                title="Log out?"
                description="Dear Customer, please check your email, we&#39;resending a restoration link to you, go to that link to generate a new password for your account."
                primaryButton={{
                    label: 'Ok, go back to Login & Sign Up',
                    handler: () => router.push(LOGIN_PAGE_URL),
                }}
            />

            <AuthLayout>
                <div className="w-auto sm:w-full ">
                    <div>
                        <MainTitle>Sign Up</MainTitle>
                        <div className="font-mont mt-2 text-sm text-black">
                            Have account?&nbsp;&nbsp;
                            <div className="inline-block font-mont text-sm text-blue font-bold hover:text-blue">
                                <Link href={LOGIN_PAGE_URL}>You can Login</Link>
                            </div>
                        </div>
                    </div>

                    {/* <div className="hidden sm:block w-[30rem]"> */}
                    <MainTabs
                        tabs={[{ label: EMAIL_TAB }, { label: PHONE_TAB }]}
                        value={activeTab}
                        onClick={(tab) => {
                            setActiveTab(tab.label);
                        }}
                    />
                    {/* </div> */}
                </div>

                {activeTab === EMAIL_TAB ? (
                    <SignUpByEmail />
                ) : (
                    <SignUpByPhone />
                )}
            </AuthLayout>
        </div>
    );
};

export default Signup;
